<template>
  <div class="main">
    <el-dialog title="高级查询" :visible.sync="dialogFormVisible" width="30%">
      <slot></slot>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleQuery">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props:{
      query: {
        type: Function,
        default: null
      }
    },
    data() {
      return {
          dialogFormVisible:false
        }
    },
    methods: {
      show(){
        this.dialogFormVisible = true;
      },
      handleQuery(){
        this.dialogFormVisible = false;
        if (this.query) {
          this.query();
        }
        // this.$emit("handleQuery")
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common_search.vue